"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const react_1 = __importStar(require("react"));
const Video = ({ source, style, shouldPlay = true, loop = true, onEnd = () => { } }) => {
    const vidRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (shouldPlay) {
            vidRef.current.play();
        }
    }, [shouldPlay]);
    return (react_1.default.createElement("video", { style: style, ref: vidRef, onEnded: () => onEnd(), loop: loop },
        react_1.default.createElement("source", { src: source, type: "video/mp4" })));
};
exports.Video = Video;
//# sourceMappingURL=video.js.map